
import React, {Component} from 'react';
import NumberFormat from 'react-number-format';
// import InputNumberCommon from '../InputNumberCommon'
import './index.scss';

class InputNumberComponent extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount = () => {
       
    }

    componentWillReceiveProps = nextProps => {
       
    }


    onChange = value => {
        this.props.onChange(value, this.props.name, this.props.params);
    }

    onFocus = () => {
        if(this.props.onFocus)
           this.props.onFocus(this.props.name)
    }
    
    
    render() {
        
        const {type,placeholder,name,className,value} = this.props;

        if (type === 'DECIMAL') {
            return ( <React.Fragment>
                <NumberFormat value={value}
                              thousandSeparator={true} 
                              name={name}
                              onFocus={this.onFocus}
                              className={className}
                              placeholder={placeholder}
                              fixedDecimalScale={true}
                              onValueChange={value => this.onChange(value)}
                              />
            </React.Fragment>) 

        } else {

        return ( <React.Fragment>
            <NumberFormat value={value}
                          thousandSeparator={true} 
                          name={name}
                          onFocus={this.onFocus}
                          className={className}
                          placeholder={placeholder}
                          fixedDecimalScale={type === 'CURRENCY'}
                          onValueChange={value => this.onChange(value)}
                          decimalScale={type === 'CURRENCY'? 2 : 0}
                          />
        </React.Fragment>) 
        }

    }


}

export default InputNumberComponent;

